import fetch from "auth/FetchInterceptor";

const DiscountService = {
  list(params = {}) {
    return fetch({
      url: "/discounts",
      method: "get",
      params,
    });
  },

  show(id, params = {}) {
    return fetch({
      url: `/discounts/${id}`,
      method: "get",
      params,
    });
  },

  create(data) {
    return fetch({
      url: "/discounts",
      method: "post",
      data,
    });
  },

  update(id, data) {
    return fetch({
      url: `/discounts/${id}`,
      method: "put",
      data,
    });
  },

  remove(id) {
    return fetch({
      url: `/discounts/${id}`,
      method: "delete",
    });
  },

  generateCoupons(id, data = {}) {
    return fetch({
      url: `/discounts/${id}/coupons`,
      method: "post",
      data,
    });
  },

  coupons(id, params = {}) {
    return fetch({
      url: `/coupons`,
      method: "get",
      params: { discount_id: id, ...params },
    });
  },

  approvals(params = {}) {
    return fetch({
      url: "/discount-approvals",
      method: "get",
      params,
    });
  },

  history(id, params = {}) {
    return fetch({
      url: `/discounts/${id}/approvals`,
      method: "get",
      params,
    });
  },

  approve(id, data = {}) {
    return fetch({
      url: `/discounts/${id}/approve`,
      method: "post",
      data,
    });
  },

  reject(id, data = {}) {
    return fetch({
      url: `/discounts/${id}/reject`,
      method: "post",
      data,
    });
  },
};

export default DiscountService;
